import { render } from "./CardFuelComponent.vue?vue&type=template&id=0d7fef60"
import script from "./CardFuelComponent.vue?vue&type=script&lang=js"
export * from "./CardFuelComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__